import React, { useState } from "react";
import { CarouselProvider, Slider, Slide, ButtonBack, ButtonNext } from "pure-react-carousel";
import "pure-react-carousel/dist/react-carousel.es.css";

/* Install pure-react-carousel using -> npm i pure-react-carousel */

export default function Index() {

  const [activePricing, setActivePricing] = useState(1)
  const [mode, setMode] = useState("auto");
  var tablePrice = 13000
  const PricingPlan = () =>{
    var isActive = "bg-black focus:ring-2 z-0 focus:ring-offset-2 focus:ring-black focus:outline-none text-base leading-none text-white rounded-full py-4 px-6" 
    var inActive = "bg-gray-100 focus:ring-2 z-0 focus:ring-offset-2 focus:ring-black focus:outline-none text-base leading-none text-gray-600 rounded-full py-4 px-6 mr-1"
    
  return(
    <div className="xl:mx-auto xl:container py-20 2xl:px-0 px-6 m-10 z-0">
    <div className="lg:flex items-center justify-between">
        <div className=" lg:w-1/2 w-full">
            <p className="text-base leading-4 text-gray-600">Choose your budget package</p>
            <h1 role="heading" className="md:text-5xl text-3xl font-extralight leading-10 mt-3 text-gray-800">
                Our pricing 
            </h1>
            <img style={{opacity:activePricing === 0?'0': '1'}} src="https://billease.ph/account/_nuxt/img/billease-logo.5e2d225.svg" className=" m-2 w-20 " alt="background circle images" />

            <p role="contentinfo" className="text-base leading-5 mt-5 text-gray-600">
                We have different plans to suit your budget. Try checkingout with the following
            </p>
            <div className="w-56">
                <div className="bg-gray-100 shadow rounded-full flex items-center mt-10">
                    <button onClick={()=>setActivePricing(0)} className={activePricing === 0 ? isActive :inActive} id="monthly">
                        SmartDesk
                    </button>
                    <button onClick={()=>setActivePricing(1)} className={activePricing === 1 ? isActive :inActive} id="annually">
                      BillEase 
                    </button>
                    
                </div>
              
            </div>
        </div>
        <div className="xl:w-1/2 lg:w-7/12 z-0  relative w-full lg:mt-0 mt-12 md:px-8" role="list">
        <div role="listitem" className="group mb-5 bg-white hover:bg-black cursor-pointer shadow rounded-lg p-8 relative z-30 mt-7">
                <div className="md:flex items-center justify-between">
                    <h2 className="text-2xl font-semibold leading-6 text-black group-hover:text-white">Dual Motor with Mahogany</h2>
                    <p className="text-2xl md:mt-0 mt-4 font-semibold leading-6 text-black group-hover:text-white ">
                        ₱ {activePricing === 0 ? '25,500':'25,999'}
                    </p>
                </div>
                <p className="md:w-80 text-base leading-6 mt-4 text-black group-hover:text-white ">Table size (120/140) x 60 x 4 with Mahogany table top</p>
                <a href="https://store.smartdeskph.co/" className="md:w-80 text-base leading-6 mt-5 text-blue-600 group-hover:text-blue-500 ">View store</a>
            </div>

            <div role="listitem" className="group bg-white hover:bg-black cursor-pointer shadow rounded-lg mt-3 flex relative z-30">
                <div className="w-2.5  h-auto bg-black rounded-tl-md rounded-bl-md" />
                <div className="w-full p-8">
                    <div className="md:flex items-center justify-between">
                        <h2 className="text-2xl font-semibold leading-6 text-black group-hover:text-white ">Dual Motor with Acacia</h2>
                        <p className="text-2xl md:mt-0 mt-4 font-semibold leading-6 text-black   group-hover:text-white ">
                            ₱ {activePricing === 0 ? '24,500':'25,000' }
                        </p>
                    </div>
                    <p className="md:w-80 text-base leading-6 mt-4 text-black group-hover:text-white ">Table size (120/140) x 60 x 4 with Acacia table top</p>
                    <a href="https://store.smartdeskph.co/" className="md:w-80 text-base leading-6 mt-5 text-blue-600 group-hover:text-blue-500 ">View store</a>
                </div>
            </div>
            <div role="listitem" className="group bg-white hover:bg-black cursor-pointer shadow rounded-lg p-8 relative z-30 mt-7">
                <div className="md:flex items-center justify-between">
                    <h2 className="text-2xl font-semibold leading-6 text-black group-hover:text-white">Dual Motor with Jointer</h2>
                    <p className="text-2xl md:mt-0 mt-4 font-semibold leading-6 text-black group-hover:text-white ">
                        ₱ {activePricing === 0 ? '23,200':'23,700'}
                    </p>
                </div>
                <p className="md:w-80 text-base leading-6 mt-4 text-black group-hover:text-white ">Table size (120/140) x 60 x 4 with Jointer table top</p>
                <a href="https://store.smartdeskph.co/" className="md:w-80 text-base leading-6 mt-5 text-blue-600 group-hover:text-blue-500 ">View store</a>
            </div>
        </div>
    </div>
</div>
  )
  }

    return <div>
        {PricingPlan()}
    </div>
    
    // PricingPlan()
}
